import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL
let cachedData = null

export const dataService = {

    async getMeetingTypes(therapistId) {
        await ensureDataLoaded(therapistId)

        if (!cachedData.meetingTypes || !Array.isArray(cachedData.meetingTypes)) {
            return []
        }

        return cachedData.meetingTypes.map(({ id, name, duration, description, price, customFields }) => ({
            id,
            name,
            duration,
            description: description || '',
            price,
            customFields: customFields || []
        }))
    },

    async getDatesAndTimes(meetingTypeId, therapistId) {
        await ensureDataLoaded(therapistId)

        if (!cachedData.meetingTypes || !Array.isArray(cachedData.meetingTypes)) {
            return {}
        }

        const meetingType = cachedData.meetingTypes.find(
            (item) => item.id === meetingTypeId
        )

        if (!meetingType || !Array.isArray(meetingType.availableDates)) {
            return {}
        }

        const availabilityMap = {}

        meetingType.availableDates.forEach(({ date, times }) => {
            if (Array.isArray(times) && times.length > 0) {
                availabilityMap[date] = [...(availabilityMap[date] || []), ...times].sort()
            }
        })

        return availabilityMap
    },

    async getTherapist(therapistId) {
        try {
            await ensureDataLoaded(therapistId)
            return cachedData.therapist?.name ?? 'Name unbekannt'
        } catch (err) {
            console.error('Error fetching therapist:', err)
            throw err
        }
    },

    getDataCollectionPermission() {
        if (!cachedData || !cachedData.therapist) {
            return null
        }
        return cachedData.therapist.dataCollectionPermission
    },

    getTherapistCountry() {
        if (!cachedData || !cachedData.therapist) {
            return null
        }
        return cachedData.therapist.country || null
    },

    getCustomFields(meetingTypeId) {
        if (!cachedData || !cachedData.meetingTypes) {
            return []
        }
        const meetingType = cachedData.meetingTypes.find(mt => mt.id === meetingTypeId)
        return meetingType?.customFields || []
    },

    async createBooking({ startTime, uid, meetingTypeId, clientData, customData, notes }) {
        console.log('Creating booking...')
        try {
            const payload = {
                startTime,
                uid,
                meetingTypeId,
                clientData,
                notes
            }

            // Add customData only if it exists
            if (customData) {
                payload.customData = customData
            }

            const response = await axios.post(
                `${BASE_URL}/api/booking`,
                payload
            )

            return response.data.statusCode
        } catch (err) {
            console.error('Error creating booking:', err)
            console.error('Error response:', err.response?.data)
            throw err
        }
    },

    clearCache() {
        cachedData = null
    }
}

async function ensureDataLoaded(therapistId) {
    if (cachedData) return

    try {
        const response = await axios.get(`${BASE_URL}/api/booking-data/${therapistId}`)
        if (response.data.success) {
            // Store the new structure directly
            cachedData = response.data.data

            // Sort meeting types by displayOrder ascending
            if (cachedData.meetingTypes && Array.isArray(cachedData.meetingTypes)) {
                cachedData.meetingTypes.sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
            }
        } else {
            throw new Error(response.data.message || 'Failed to fetch booking data')
        }
    } catch (err) {
        console.error('Booking data fetch error:', err)
        throw err
    }
}